module.exports = __webpack_public_path__ + "static/media/gbp-icon.83680250.svg";